type tt = 'tt';
type lark = 'lark';
type web = 'web' | 'h5';
type weapp = 'weapp';

type TT = 'TT';
type LARK = 'LARK';
type WEB = 'WEB' | 'H5';
type WEAPP = 'WEAPP';

export type VChartEnvType = tt | lark | weapp | web | TT | LARK | WEB | WEAPP;
